import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';

//import { Button, FormControlLabel, MenuItem, Radio, Typography, Icon, IconButton } from 'material-ui';
import { InputLabel, Select as MSelect, Radio, MenuItem, TextField, Checkbox, FormControlLabel, Divider, Button, Paper, Typography, FormControl, FormHelperText, Icon, IconButton } from 'material-ui';

import $ from "jquery";
import ReactTable from "react-table";
import axios from 'axios/index';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import Loader from "other-components/loader/loader";
import { withAlert } from 'react-alert';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import moment from 'moment';
import 'react-select/dist/react-select.css'
import Select from 'react-select';
import 'react-day-picker/lib/style.css';
import { confirmAlert } from 'react-confirm-alert';
import Tooltip from 'material-ui/Tooltip';
import { BillPaymnetConfig } from './BillPaymnetConfig';
// import NumericInput from 'react-numeric-input';
// import NumberFormat from 'react-number-format';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import printjs from 'print-js';


const styles = theme => ({
    layoutRoot: {},
    paper: { padding: '10px' },
    input: {
        'margin-top': 0
    }
});

var id = null;
var ID_CHEQUE_BOOK = null;
var chequeId = null;
var update_id = null;
var create_date = null;
var doc_number = null;
var bank_name = null;
var branch_name = null;
var acc_number = null;
var total_pages = null;
var addBillPayment = [];
var ledgerIdNameArray = [];
var billPaymentReportDetails = null;
class BillPaymnet extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loadBanks: [],
            value: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            isActive: true,
            loading: false,
            supplierArray: [],
            supplier: '',
            billCheck: [],
            billPaymnetArry: [],
            checkedPayemnts: [],
            onSubmit: true,

            totalPayAmount: '',
            newTotal: '',
            totalPayAmountDisplay: 0,

            // payment method cards hidden
            cashCardHidden: true,
            cardCardHidden: true,
            cardChequeHidden: true,
            cardBankDepositHidden: true,
            payMode: true,
            bankAccountNumbers: [],

            selectedPaymentType: 0,
            // loadPayTypes: [{ value: "cash", label: "Cash" },
            // { value: "card", label: "Card" },
            // { value: "cheque", label: "Cheque" },
            // { value: "bank", label: "Bank Deposit" }],
            loadPayTypes: [],

            paymentModeAr: [],

            ledgerIdNameArray: []
        };

        this.loadBanks();
        this.loadSupplierDetails();
        this.loadPaymentTypesDB();
        // this.loadData();
        this.updateBillAmount = this.updateBillAmount.bind(this);
        this.handleCheckControlAccount = this.handleCheckControlAccount.bind(this);
        this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);
    }

    // clear all details
    clearAll = () => {
        this.setState({
            data: [],
            loadBanks: [],
            value: '',
            date: moment(new Date()).format("YYYY-MM-DD"),
            isActive: true,
            loading: false,
            supplierArray: [],
            supplier: '',
            billCheck: [],
            billPaymnetArry: [],
            checkedPayemnts: [],
            onSubmit: true,

            totalPayAmount: '',
            newTotal: '',
            totalPayAmountDisplay: 0,

            // payment method cards hidden
            cashCardHidden: true,
            cardCardHidden: true,
            cardChequeHidden: true,
            cardBankDepositHidden: true,
            payMode: true,

            selectedPaymentType: 0,
            loadPayTypes: [],
            paymentModeAr: [],
            ledgerIdNameArray: [],

        });

        $('#ref_number').val('');
        $('#payer').val('');
        $('#narration').val('');
    }

    // load bank account numbers where bank
    loadBannkAccountNumers = (selectedOption) => {

        if (null == selectedOption) {
            this.setState({ selectedBank: '' });
        } else {
            this.setState({ selectedBank: selectedOption.value });

            var bankAccountNumbers = [];

            var bankName = {
                bankName: selectedOption.value
            }

            axios.post(window.accountServer + '/bank/loadBankAccountNumbers', bankName)
                .then(response => {

                    for (let i = 0; i < response.data.accountNumbers.length; i++) {

                        bankAccountNumbers.push({
                            label: response.data.accountNumbers[i].ACCOUNT_NO,
                            value: response.data.accountNumbers[i].ID_LEDGER_ACCOUNT
                        });
                    }
                    this.setState({ bankAccountNumbers: bankAccountNumbers });

                }).catch(function (error) {
                    console.log("err " + error);
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }

    }

    // load payment types 
    loadPaymentTypesDB() {
        var paymentTypes = [];

        // axios.get(window.systemServer + '/system/loadBanks')
        axios.get(window.accountServer + '/normalPayment/getPaymentTypes')
            .then(response => {

                if (response.data.success) {
                    for (let i = 0; i < response.data.paymentTypes.length; i++) {

                        paymentTypes.push({
                            value: response.data.paymentTypes[i].ID_PAYMENT_TYPE,
                            label: response.data.paymentTypes[i].NAME
                        });
                    }
                    this.setState({ loadPayTypes: paymentTypes });
                } else {
                    console.log('payment type loding faild');
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error loding payment types");
                // alert("No internet connection or Internal error");
            });
    }


    // romove payment mode
    removePaymentMode(rowId, paymentAmount) {

        var paidPaymentModeAr = this.state.paymentModeAr;
        var removedVal = parseFloat(paymentAmount);

        paidPaymentModeAr.splice(rowId, 1);
        this.setState({ paymentModeAr: paidPaymentModeAr });


        var oldTotal = this.state.totalPayAmount;
        var newTotal = (oldTotal - removedVal);
        var balance = oldTotal + removedVal
        this.setState({
            newTotal: newTotal,
            totalPayAmount: balance,
            totalPayAmountDisplay : balance
        });
    }

    // add cash details to table
    addCashAmountT = (model) => {

        var cashAmount = model.cashAmount;
        if (cashAmount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            var paymentMode = {}
            paymentMode.paymentTypeName = "CASH";
            paymentMode.paymentType = 1;
            paymentMode.ledgerId = 6
            paymentMode.cardType = "";
            paymentMode.bank = "";
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = "";
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.number = "";
            paymentMode.date = "";
            paymentMode.paymentAmount = cashAmount;

            this.setState(prevState => ({
                paymentModeAr: [...prevState.paymentModeAr, paymentMode]
            }));

            this.setState({
                cashCardHidden: true,
                onSubmit: false
            });
            var balance = this.state.totalPayAmount - cashAmount
            this.setState({
                totalPayAmount: balance
            });
            // this.form.reset()
            // this.clearValuePaymentMethod()
        }

    };

    // add card details to table
    addCardAmountT = (model) => {

        var cardType = model.cardType;
        var bankName = model.bankName;
        var cardNo = model.cardNo;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {

            var paymentMode = {}
            paymentMode.paymentTypeName = "CARD";
            paymentMode.paymentType = 3;
            paymentMode.ledgerId = 2
            paymentMode.cardType = model.cardType;
            paymentMode.bank = bankName;
            paymentMode.branch = "";
            paymentMode.accountNo = "";
            paymentMode.cardNo = cardNo;
            paymentMode.number = cardNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = model.expiredDate;
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = model.expiredDate;
            paymentMode.paymentAmount = amount;

            this.setState(prevState => ({
                paymentModeAr: [...prevState.paymentModeAr, paymentMode]
            }));

            var balance = this.state.totalPayAmount - amount;

            this.setState({
                cardCardHidden: true,
                onSubmit: false,
                totalPayAmount: balance
            });
            // this.clearValuePaymentMethod()
        }
    };

    // add cheque Details to table
    addChequeAmountT = (model) => {

        var bankName = model.bankName;
        var chequeNo = model.chequeNo;
        var accountNo = model.accountNo;
        var chequeDate = model.chequeDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {
            var paymentMode = {}
            paymentMode.paymentTypeName = "CHEQUE";
            paymentMode.paymentType = 2;
            paymentMode.ledgerId = 6
            paymentMode.cardType = "";
            paymentMode.bank = bankName;
            paymentMode.branch = "";
            paymentMode.cardNo = "";
            paymentMode.accountNo = accountNo;
            paymentMode.number = chequeNo;
            paymentMode.chequeNo = chequeNo;
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = "";
            paymentMode.slipNo = "";
            paymentMode.date = chequeDate;
            paymentMode.paymentAmount = amount;

            this.setState(prevState => ({
                paymentModeAr: [...prevState.paymentModeAr, paymentMode]
            }));

            var balance = this.state.totalPayAmount - amount;

            this.setState({
                cardChequeHidden: true,
                onSubmit: false,
                totalPayAmount: balance
            });
            // this.clearValuePaymentMethod()
        }
    }

    // add bank Details to table
    addBankDepositAmountT = (model) => {

        var bankName = model.bankName;
        var branch = model.branch;
        var receiptNo = model.receiptNo;
        var depositDate = model.depositDate;
        var amount = model.amount;

        if (amount < 0) {
            this.props.alert.info("Cannot add minus values");
        } else {
            var paymentMode = {}
            paymentMode.paymentTypeName = "BANK DEPOSIT";
            paymentMode.paymentType = 4;
            paymentMode.ledgerId = 6
            paymentMode.cardType = "";
            paymentMode.bank = bankName;
            paymentMode.branch = model.branch;
            paymentMode.cardNo = "";
            paymentMode.accountNo = "";
            paymentMode.number = receiptNo;
            paymentMode.chequeNo = "";
            paymentMode.cardExpireDate = "";
            paymentMode.depositDate = depositDate;
            paymentMode.slipNo = receiptNo;
            paymentMode.date = depositDate;
            paymentMode.paymentAmount = amount;

            this.setState(prevState => ({
                paymentModeAr: [...prevState.paymentModeAr, paymentMode]
            }));

            var balance = this.state.totalPayAmount - amount;

            this.setState({
                cardBankDepositHidden: true,
                onSubmit: false,
                totalPayAmount: balance
            });
            // this.clearValuePaymentMethod()
        }
    }

    addNew() {
        // alert()
        this.setState({
            billPaymnetArry: addBillPayment

        });
        this.totalPayAmount(addBillPayment)
    }


    // hidden payment methods cards
    loadPaymentTypes = (selectedOption) => {
        if (selectedOption != null) {
            var selectPaymentType = selectedOption.label;

            this.setState({ selectedPaymentType: selectedOption.value });

            if ("CASH" == selectPaymentType) {
                this.setState({ cashCardHidden: false });
                this.setState({ cardCardHidden: true });
                this.setState({ cardChequeHidden: true });
                this.setState({ cardBankDepositHidden: true });
            }

            if ("CARD" == selectPaymentType) {
                this.setState({ cashCardHidden: true });
                this.setState({ cardCardHidden: false });
                this.setState({ cardChequeHidden: true });
                this.setState({ cardBankDepositHidden: true });
            }

            if ("CHEQUE" == selectPaymentType) {
                this.setState({ cashCardHidden: true });
                this.setState({ cardCardHidden: true });
                this.setState({ cardChequeHidden: false });
                this.setState({ cardBankDepositHidden: true });
            }

            if ("BANK DEPOSIT" == selectPaymentType) {
                this.setState({ cashCardHidden: true });
                this.setState({ cardCardHidden: true });
                this.setState({ cardChequeHidden: true });
                this.setState({ cardBankDepositHidden: false });
            }
        }
        else {
            this.setState({ cashCardHidden: true });
            this.setState({ cardCardHidden: true });
            this.setState({ cardChequeHidden: true });
            this.setState({ cardBankDepositHidden: true });
            this.setState({ selectedPaymentType: '' });
        }


    }

    handleTransactionDateChange = (event) => {
        // alert(event.target.value)

        this.setState({
            date: event.target.value
        });
    };

    handleLedgerSupplier = (selectedOption) => {
        this.setState({
            supplier: selectedOption,
            checkedPayemnts: []
        });
        // alert(selectedOption.label)
        if (selectedOption != null) {
            this.loadBySupplier(selectedOption.value)
            this.setState({
                billPaymnetArry: [],
                data: []

            });
            addBillPayment = [];
        } else {
            this.setState({
                data: []
            });
        }

    }

    loadBySupplier(supplier) {
        const billObj = {
            supplier: supplier
        }
        var resObj;
        // axios.post('http://localhost:5009/billEntries/getAllBillEntriesBySupplier', billObj)
        axios.post(window.accountServer + '/billEntries/getAllBillEntriesBySupplier', billObj)
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.billEntries;
                    console.log(resObj)
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }


    handleCheckControlAccount(e, row_id, data_id, ledger_number, row) {
        // addBillPayment = this.state.billPaymnetArry
        console.log("3" + this.state.billPaymnetArry)
        var newDateAr = this.state.data.slice();
        var amount_id = "#billAmount_" + data_id;
        var due_id = "#dueAmount_" + data_id;
        // alert()
        var current_bill_amount = $(amount_id).val()
        var current_bill_due_amount = $(due_id).val()
        console.log('row', row);
        if ($("#checkBill_" + data_id).prop('checked') == true) {
            //let checkedPayemnts = this.state.checkedPayemnts.slice();
            //checkedPayemnts.push(row);
            this.setState({
                checkedPayemnts: this.state.checkedPayemnts.concat([row])
            },
                () => {
                    console.log('checkedPayemnts', this.state.checkedPayemnts);
                });
            newDateAr[row_id].dueAmountCheck = true;
            addBillPayment.push({
                id: data_id,
                row_id: row_id,
                supplier: this.state.supplier.label,
                ledger_number_view: ledger_number,
                paid_amount: current_bill_amount,
                due_amount: current_bill_due_amount
            })
        } else {
            let checkedPayemnts = [];
            for (let x = 0; x < this.state.checkedPayemnts.length; x++) {
                if (row.row_id != this.state.checkedPayemnts[x].row_id) {
                    console.log('found');
                    checkedPayemnts.push(this.state.checkedPayemnts[x]);
                }
            }
            this.setState({
                checkedPayemnts: checkedPayemnts
            },() => {
                console.log('checkedPayemnts', this.state.checkedPayemnts);
            });
            newDateAr[row_id].dueAmountCheck = false;
            var index = addBillPayment.map(function (x) { return x.row_id; }).indexOf(row_id);
            addBillPayment.splice(index, 1);
        }
        this.setState({
            data: newDateAr
        });
        this.totalPayAmount(addBillPayment)
        console.log("4" + addBillPayment)
        console.log("5" + this.state.billPaymnetArry)
    };


    updateBillAmount(e, due_value, data_id, row_id) {
        // addBillPayment = this.state.billPaymnetArry
        console.log("1" + this.state.billPaymnetArry)
        var newDateAr = this.state.data.slice();
        var id = '#' + e.target.id;
        var amount = e.target.value;

        if (0 == e.target.value || "" == e.target.value || null == e.target.value || undefined == e.target.value) {
            if ($("#checkBill_" + data_id).prop('checked') == true) {
                newDateAr[row_id].dueAmountCheck = false;
            }
            newDateAr[row_id].dueAmountChange = false;
            var index = addBillPayment.map(function (x) { return x.row_id; }).indexOf(row_id);
            addBillPayment.splice(index, 1);

        } else {
            newDateAr[row_id].dueAmountChange = true;
        }
        if (isNaN(amount)) {
            amount = amount.replace(/[^0-9\.]/g, '');
            if (amount.split('.').length > 2) {
                amount = amount.replace(/\.+$/, "");
            }
        }
        if (Number(due_value) < Number(amount)) {
            this.props.alert.error("pay amount higher than oustanding price");
            if ($("#checkBill_" + data_id).prop('checked') == true) {
                newDateAr[row_id].dueAmountCheck = false;
            }
            newDateAr[row_id].dueAmountChange = false;
        } else {
            // alert(data_id)
            var total = Number(due_value) - Number(amount);
            $('#dueAmount_' + data_id).val(total);
            newDateAr[row_id].dueAmount = total;
            total = total.toString();
            console.log(total)
            $(id).val(amount)
            if ($("#checkBill_" + data_id).prop('checked') == true) {
                for (var i in addBillPayment) {
                    if (addBillPayment[i].row_id == row_id) {
                        addBillPayment[i].paid_amount = amount;
                        addBillPayment[i].due_amount = total;
                        break; //Stop this loop, we found it!
                    }
                }
                this.setState({
                    billPaymnetArry: addBillPayment
                });
            }
        }

        this.setState({ data: newDateAr });
        this.totalPayAmount(addBillPayment)
        console.log("2" + this.state.billPaymnetArry)
    }

    totalPayAmount(billAmount) {
        var total_amount = Number(0);
        for (let i = 0; i < billAmount.length; i++) {
            total_amount += Number(billAmount[i].paid_amount)
        }

        this.setState({
            totalPayAmount: total_amount,
            newTotal: total_amount,
            totalPayAmountDisplay : total_amount
        }, () => {
                console.log('totalPayAmount', this.state.totalPayAmount);
            });
        if (total_amount != 0) {
            this.setState({
                payMode: false
            });

        } else {
            this.setState({
                payMode: true
            });
        }
    }

    loadData() {
        var resObj;
        // axios.get('http://localhost:5009/billEntries/getAllBillEntries')
        axios.get(window.accountServer + '/billEntries/getAllBillEntries')
            .then(response => {
                if (response.data.success) {
                    resObj = response.data.billEntries;
                    console.log(resObj)
                    this.appendToTable(resObj)
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        // this.closeNewCustomerDialog();
    }



    appendToTable(checkBookObj) {

        console.log(checkBookObj)
        var data = [];
        var active;
        for (var i = 0; i < checkBookObj.length; i++) {
            if (checkBookObj[i].IS_ACTIVE == 1) {
                active = 'Active'
            } else {
                active = 'Inactive'

            }
            // var create_date = checkBookObj[i].CREATED_DATE
            // create_date = create_date.toString().substring(0, 10);
            data.push({
                row_id: i,
                update_id: checkBookObj[i].ID_BILL_ENTRIES,
                // id: "B-" + checkBookObj[i].ID_LEDGER_ACCOUNT,
                transaction_date: checkBookObj[i].TRANSACTION_DATE,
                doc_number: checkBookObj[i].DOCUMENT_NO,
                ref_number: checkBookObj[i].REFERENCE_NO,
                create_date: checkBookObj[i].DATE,
                ledger_number: checkBookObj[i].ID_LEDGER_ACCOUNT,
                oustanding_amount: checkBookObj[i].OUSTANDING_AMOUNT,
                dueAmount: checkBookObj[i].DUE_AMOUNT,
                dueAmountCheck: false,
                is_active: checkBookObj[i].IS_ACTIVE,
                // mainAccountId: checkBookObj[i].ID_MAIN_ACCOUNT,
                // active: active
            });

        }

        this.setState({ data: data });
        // this.setState({ loading: false });
    }


    loadBanks() {
        var banks = [];
        // axios.get('http://localhost:5009/bank/getBankDetails')
        axios.get(window.accountServer + '/bank/getBankDetails')
            .then(response => {

                for (let i = 0; i < response.data.bankDetails.length; i++) {
                    console.log("rrrr" + JSON.stringify(response.data.bankDetails[i].bank_name));
                    banks.push({
                        value: response.data.bankDetails[i].BANK_NAME,
                        label: response.data.bankDetails[i].BANK_NAME
                    });
                }
                this.setState({ loadBanks: banks });

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }


    loadSupplierDetails() {
        var supplierArray = [];
        const suplierObj = {
            typeId: 1
        }
        // axios.post('http://192.168.8.138:5004/supplier/getSupplierByType', suplierObj)
        axios.post(window.inventoryServer + '/supplier/getSupplierByType', suplierObj)
            .then(response => {
                if (response.data.success) {
                    // resObj = response.data.ledgerAccountDetails;
                    if (response.data.result.length == 0) {
                        this.setState({ supplierArray: [] });
                    } else {
                        for (let i = 0; i < response.data.result.length; i++) {
                            console.log("rrrr" + JSON.stringify(response.data.result[i].ID_LEDGER_ACCOUNT));
                            supplierArray.push({
                                value: response.data.result[i].ID_SUPPLIER_PROFILE,
                                label: response.data.result[i].SUPPLIER_NAME
                            });
                        }
                        this.setState({ supplierArray: supplierArray });

                    }
                }
            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    handleBank = (selectedOption) => {
        this.setState({
            bank: selectedOption
        });
        if (selectedOption != null) {
            this.loadBranches(selectedOption.label)
        }
    }

    handleBranch = (selectedOption) => {
        this.setState({
            branch: selectedOption
        });
        // alert(selectedOption)
        if (selectedOption != null && this.state.bank != null && this.state.bank != '') {
            this.loadAcounts(this.state.bank.label, selectedOption.label)
        }

    }

    handleAcount = (selectedOption) => {
        this.setState({
            account: selectedOption
        });
    }

    handlePageCount = (selectedOption) => {
        this.setState({
            pageCount: selectedOption
        });
    }

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseActive = () => {
        this.setState({ active: false });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    // active cheque
    onActive = (model) => {
        this.chequeStatusChange(model, 1);
    }
    // delete department
    onDelete = (model) => {
        this.chequeStatusChange(model, 0);
    };

    chequeStatusChange(model, is_active) {

        const chequebj = {
            id: model.chequeId,
            is_active: is_active
        }
        var chequeNum = []
        var active;
        // axios.post('http://localhost:5009/chequeBook/updateChequeStatus', chequebj)
        axios.post(window.accountServer + '/chequeBook/updateChequeStatus', chequebj)
            .then(response => {
                if (response.data.success) {
                    this.loadCheckBookDetails(model.ID_CHEQUE_BOOK);
                    this.handleCloseActive()
                    this.handleCloseDelete()
                }

            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

    }


    loadAcounts(bank, branch) {
        var accounts = [];
        const bankObj = {
            bank: bank,
            branch: branch
        }

        // axios.post('http://localhost:5009/bank/getBranchAcounts', bankObj)
        axios.post(window.accountServer + '/bank/getBranchAcounts', bankObj)
            .then(response => {
                if (response.data.accounts.length == 0) {
                    this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.accounts.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.accounts[i].ACCOUNT_NO));
                        accounts.push({
                            value: response.data.accounts[i].ACCOUNT_NO,
                            label: response.data.accounts[i].ACCOUNT_NO
                        });
                    }
                    this.setState({ accounts: accounts });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadBranches(bank) {
        var branches = [];
        const bankObj = {
            bank: bank
        }

        // axios.post('http://localhost:5009/bank/getBranchesByBankName', bankObj)
        axios.post(window.accountServer + '/bank/getBranchesByBankName', bankObj)
            .then(response => {
                if (response.data.bankBranches.length == 0) {
                    this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.bankBranches.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.bankBranches[i].BRANCH));
                        branches.push({
                            value: response.data.bankBranches[i].ACCOUNT_NO,
                            label: response.data.bankBranches[i].BRANCH
                        });
                    }
                    this.setState({ branches: branches });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    loadCheckBookDetails(id) {
        const chequebj = {
            id: id
        }
        var chequeNum = []
        var active;
        // axios.post('http://localhost:5009/chequeBook/getchequeById', chequebj)
        axios.post(window.accountServer + '/chequeBook/getchequeById', chequebj)
            .then(response => {
                if (response.data.chequeBookDetails.length == 0) {
                    // this.setState({ branches: [], branch: '' });
                } else {
                    for (let i = 0; i < response.data.chequeBookDetails.length; i++) {
                        console.log("rrrr" + JSON.stringify(response.data.chequeBookDetails[i].CHEQUE_NO));
                        if (response.data.chequeBookDetails[i].IS_ACTIVE == 1) {
                            active = 'Active'
                        } else {
                            active = 'Inactive'

                        }

                        chequeNum.push({
                            id: i + 1,
                            cheque_no: response.data.chequeBookDetails[i].CHEQUE_NO,
                            status: active,
                            chequeId: response.data.chequeBookDetails[i].ID_CHEQUE_BOOK_HEADER,
                            ID_CHEQUE_BOOK: response.data.chequeBookDetails[i].ID_CHEQUE_BOOK
                        })
                    }
                    this.setState({ chequesEdit: chequeNum });

                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }

    // onSubmit = (model) => {

    //     this.setState({ onSubmit: true });
    //     alert(this.state.onSubmit)
    //     if (this.state.onSubmit) {
    //         this.saveCheckBook(model);
    //     }




    // };

    saveBillPayment() {
        // console.log(this.state.billPaymnetArry)
        console.log('billPaymnetArry', this.state.billPaymnetArry)
        console.log('paymentModeAr', this.state.paymentModeAr)
        console.log('addbillpayment', addBillPayment)
        console.log('ledgerIdNameArray', this.state.ledgerIdNameArray)
        console.log('data', this.state.data)
        var transactionLedgerDetails = [];
        var transactionLedgerHeader = {};
        var transactionBillPaymentDetails = [];
        var transactionBillPaymentHeader = {};
        var ref_no = $('#ref_number').val();
        var payer = $('#payer').val();
        var narration = $('#narration').val();
        var totalOfPayedPaymentMode = 0;

        for (let j = 0; j < this.state.paymentModeAr.length; j++) {
            totalOfPayedPaymentMode = totalOfPayedPaymentMode + parseFloat(this.state.paymentModeAr[j].paymentAmount);

        }

        if (null == this.state.billPaymnetArry || undefined == this.state.billPaymnetArry || 0 == this.state.billPaymnetArry.length) {

            this.props.alert.info("No BillPayment Data to Save. Please Select Supplier Row First !");
            this.setState({ loading: false });
        } else {

            if (null == this.state.paymentModeAr || undefined == this.state.paymentModeAr || 0 == this.state.paymentModeAr.length) {
                this.props.alert.info("No Selected Mode to Save. Please Select Payment Mode First !");
                this.setState({ loading: false });
            } else {

                console.log("totalOfPayedPaymentMode > " + totalOfPayedPaymentMode)
                console.log("this.state.totalPayAmountDisplay = " + this.state.totalPayAmountDisplay)
                if (this.state.totalPayAmountDisplay < totalOfPayedPaymentMode) {

                    this.props.alert.info("You can't pay for more than you selected");
                    this.setState({ loading: false });

                } else if (this.state.totalPayAmountDisplay > totalOfPayedPaymentMode) {

                    this.props.alert.info("Not Enough Amount");
                    this.setState({ loading: false });
                } else {
                    console.log(this.state.paymentModeAr)
                    for (let i = 0; i < this.state.paymentModeAr.length; i++) {
                        var array = [
                            this.state.paymentModeAr[i].ledgerId,
                            this.state.paymentModeAr[i].paymentType,
                            null,
                            this.state.paymentModeAr[i].paymentAmount,
                            null,
                            null,
                            null,
                            1,
                            null,
                        ]
                        transactionLedgerDetails.push(array)

                    }

                    console.log(this.state.billPaymnetArry)
                    for (let i = 0; i < this.state.billPaymnetArry.length; i++) {
                        var array = [
                            this.state.billPaymnetArry[i].ledger_number_view,
                            null,
                            // 1,
                            null,
                            null,
                            this.state.billPaymnetArry[i].paid_amount,
                            null,
                            null,
                            1,
                            null,
                        ]
                        transactionLedgerDetails.push(array)

                    }


                    for (let i = 0; i < this.state.billPaymnetArry.length; i++) {
                        var array = [
                            this.state.billPaymnetArry[i].ledger_number_view,
                            this.state.billPaymnetArry[i].due_amount,
                            this.state.billPaymnetArry[i].due_amount,
                            this.state.billPaymnetArry[i].paid_amount,
                            ref_no,
                            null,
                            this.state.date,
                            this.state.billPaymnetArry[i].id,
                        ]
                        transactionBillPaymentDetails.push(array)

                    }

                    transactionLedgerHeader = {
                        TANSACTION_TYPE: "BILL_PAYMENT",
                        DOCUMENT_NO: ref_no,
                        IS_ACTIVE: 1,
                        DATE: this.state.date,
                    }

                    transactionBillPaymentHeader = {
                        TRANSACTION_DATE: this.state.date,
                        REFERENCE_NO: ref_no,
                        SUPPLIER: this.state.supplier.label,
                        PAYEE: payer,
                        NARRATION: narration
                    }

                    var transactionObj = {
                        transactionLedgerHeader,
                        transactionLedgerDetails

                    }

                    var billPaymentObj = {
                        transactionBillPaymentHeader,
                        transactionBillPaymentDetails

                    }
                    console.log(transactionObj)

                    var billPaymentReportDetails = {
                        transactionBillPaymentHeader,
                        //payments: this.state.checkedPayemnts,
                        paymentMode: this.state.paymentModeAr,
                        billpaymentarray: this.state.billPaymnetArry,
                        totalOfPayedPaymentMode,
                        totalpayment: this.state.totalPayAmount
                    }
                    let ledgerIds = [];
                    for (let i = 0; i < this.state.checkedPayemnts.length; i++) {
                        ledgerIds.push(this.state.checkedPayemnts[i].ledger_number);
                    }
                    var ledgerDetail = {
                        ledgerIds: ledgerIds
                    }

                    // axios.post('http://localhost:5009/transactionLedger/bulkInsertBillPayment ', billPaymentObj)
                    axios.post(window.accountServer + '/transactionLedger/bulkInsertBillPayment ', billPaymentObj)
                        .then(response => {
                            console.log(response)


                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });

                    // axios.post('http://localhost:5009/billEntries/updateBillEntryById ', this.state.billPaymnetArry)
                    axios.post(window.accountServer + '/billEntries/updateBillEntryById ', this.state.billPaymnetArry)
                        .then(response => {
                            console.log(response)
                            this.props.alert.success("bill payment added successfully.");

                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });

                    // axios.post('http://localhost:5009/transactionLedger/bulkInsert ', transactionObj)
                    axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
                        .then(response => {
                            console.log(response)
                            if (response.data.success == true) {
                                var payMod = {
                                    id: response.data.transaction_header_id,
                                    paymentModeAr: this.state.paymentModeAr
                                }
                                // axios.post('http://localhost:5009/billEntries/addbillEntryPayMod ', payMod)
                                axios.post(window.accountServer + '/billEntries/addbillEntryPayMod ', payMod)
                                    .then(response => {
                                        console.log(response)
                                        if (response.data.success == true) {

                                        }
                                        this.clearValue()

                                    }).catch(function (error) {
                                        console.log("err " + error);
                                        console.log("No internet connection or Internal error");
                                        // alert("No internet connection or Internal error");
                                    });
                            }
                            this.clearValue()

                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });



                    axios.post(window.accountServer + '/ledgerAccount/getLedgerDataForBillPaymentReport', ledgerDetail)
                        //axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
                        .then(response => {
                            console.log('getLedgerDataForBillPaymentReport', response)
                            if (response.data.success = true) {
                                console.log("done..");
                            }

                            /*for(let i=0;i<response.data.resultLedger.length;i++){
                                var ledgerIdNameDetail = [
                                     ledgerNumber=reponse.dat.resultLedger[i].ID_LEDGER_ACCOUNT
                                ]
                            }*/

                            var checkedPayemnts = [...this.state.checkedPayemnts];

                            for (let i = 0; i < response.data.resultLedger.length; i++) {
                                for (let y = 0; y < checkedPayemnts.length; y++) {
                                    if (checkedPayemnts[y].ledger_number == response.data.resultLedger[i].ID_LEDGER_ACCOUNT) {
                                        checkedPayemnts[y].ledger_name = response.data.resultLedger[i].NAME;
                                    }
                                }
                                /*   var ledgerIdNameDetail = [
                                      response.data.resultLedger[i].ID_LEDGER_ACCOUNT,
                                      response.data.resultLedger[i].NAME
                                  ]
                                  checkedPayemnts.push(ledgerIdNameDetail) */

                            }
                            console.log('checkedPayemnts with name', checkedPayemnts);

                            var billPaymentReportDetailsWithName = {
                                billPaymentReportDetails,
                                payments: this.state.checkedPayemnts
                            }

                            var path = null;
                            axios.post(window.reportServer + '/billPaymentReport/get/billPaymentReport', billPaymentReportDetailsWithName)
                                //axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
                                .then(response2 => {
                                    console.log(response2)
                                    if (response2.data.success = true) {
                                        path = response2.data.path;
                                        path = window.reportServer + "/" + path;
                                        const url = path;
                                        window.open(url, '_blank');
                                        //console.log("done..");

                                        var address = response2.data.path;
                                        address = window.reportServer + "/" + address;
                                        // address = "http://localhost:2008/" + address;

                                        printjs({ printable: address, type: 'pdf', showModal: true })
                                        //console.log("done..");
                                    }
                                    this.clearValue()
                                }).catch(function (error) {
                                    console.log("err " + error);
                                    console.log("No internet connection or Internal error");
                                });

                        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
                        });

                    console.log('billPaymentReportDetails', billPaymentReportDetails);
                }
            }
        }
    }

    clearValue = () => {
        this.form.reset();
        this.setState({
            billPaymnetArry: [],
            data: [],
            paymentModeAr: []
        });
    }

    clearValuePaymentMethod = () => {

        this.setState({
            loadPayTypes: [],
        });
    }

    componentWillMount() { }

    render() {
        const { classes } = this.props;

        var borderStyle = {
            'border-bottom': '4px solid darkgrey',
            'background-color': 'lightgrey',
            'border-style': 'inset'
        };

        if (this.state.loading) {
            return (<Loader />);
        }

        else {

            return (
                <div className="pl-8">
                    <div className="subtitle-color p-8">
                        <h2>Create New Bill Payment</h2>
                    </div>
                    <Formsy
                        onValidSubmit={this.onSubmit}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                        ref={(form) => this.form = form}
                        className="flex flex-col justify-center"
                    >
                        <fieldset style={borderStyle} className="mt-8 mr-16  p-8 pb-16 bill-payment-form-color ">
                            <div className="block">
                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" >Transaction Date</div>
                                    <TextField
                                        className="block"
                                        type="date"
                                        name='date'
                                        value={this.state.date}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        onChange={this.handleTransactionDateChange}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                {/* <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block"> */}
                                {/* <div className="block" >Transaction Code</div>
                                    <TextFieldFormsy
                                        className="block"
                                        name='transaction_code'
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        disabled
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    /> */}
                                {/* </div> */}
                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" >Reference Number</div>
                                    <TextField
                                        className="block"
                                        name='ref_number'
                                        id='ref_number'
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" > Payer</div>
                                    <TextField
                                        className="block"
                                        name='payer'
                                        id='payer'
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>
                                <div className="w-full sm:w-1/2 md:w-1/5 px-8  inline-block">
                                    <div className="block" >Narration</div>
                                    <TextField
                                        className="block"
                                        name='narration'
                                        id='narration'
                                        //value={this.state.latePaymentMonthlyCharge}
                                        //defaultValue={this.state.latePaymentMonthlyCharge}
                                        className={classes.textField}
                                        //onChange={this.handleTextBoxChange('latePaymentMonthlyCharge')}
                                        //margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />

                                </div>

                            </div>

                            <div className="block mt-16">
                                <div className="w-full sm:w-1/2 md:w-1/6 px-8  inline-block">
                                    Supplier(Expences)
                                        <Select
                                        className="block"
                                        name="form-field-name"
                                        placeholder="Select Supplier"
                                        value={this.state.supplier}
                                        onChange={this.handleLedgerSupplier}
                                        options={this.state.supplierArray}
                                    />
                                </div>

                            </div>


                            <Divider className=" mt-16" />

                            <ReactTable
                                data={this.state.data}
                                columns={[

                                    {
                                        Header: "Transaction Date",
                                        // className: "justify-center",
                                        accessor: "transaction_date"
                                    },
                                    // {
                                    //     Header: "Document Number",
                                    //     // className: "justify-center",
                                    //     accessor: "doc_number"
                                    // },
                                    {
                                        Header: "Reference Number",
                                        // className: "justify-center",
                                        accessor: "ref_number"
                                    },
                                    {
                                        Header: "Bill Date",
                                        // className: "justify-center",
                                        accessor: "create_date"
                                    },
                                    {
                                        Header: "Ledger Number",
                                        // className: "justify-center",
                                        accessor: "ledger_number"
                                    },
                                    {
                                        Header: "Oustanding Amount",
                                        // className: "justify-center",
                                        accessor: "oustanding_amount"

                                    }, {
                                        Header: "Due Amount",
                                        // className: "justify-center",
                                        accessor: "due_amount",
                                        Cell: row => (
                                            <div >
                                                <TextField
                                                    id={"dueAmount_" + row.original.update_id}
                                                    value={row.original.dueAmount}
                                                    disabled
                                                    name="dueAmount"
                                                />

                                            </div>
                                        ),

                                    }, {
                                        Header: "Payment",
                                        // className: "justify-center",
                                        accessor: "payment",

                                        Cell: row => (
                                            <div>
                                                <TextField
                                                    id={"billAmount_" + row.original.update_id}
                                                    name="billAmount"
                                                    // onChange={this.updateBillAmount(e)}
                                                    onChange={(ev) => { this.updateBillAmount(ev, row.original.oustanding_amount, row.original.update_id, row.original.row_id) }}
                                                />
                                            </div>
                                        ),

                                    },
                                    {
                                        Header: "Select",
                                        accessor: "select",
                                        className: "justify-center",
                                        Cell: row => (


                                            <div>
                                                <Checkbox
                                                    // checked={false}
                                                    // className="abd"
                                                    id={"checkBill_" + row.original.update_id}
                                                    ref={'ref_' + row.original.update_id}
                                                    value="checkedA"
                                                    disabled={row.original.dueAmountChange ? false : true}
                                                    checked={row.original.dueAmountCheck ? true : false}
                                                    onChange={(ev) => {
                                                        this.handleCheckControlAccount(
                                                            ev,
                                                            row.original.row_id,
                                                            row.original.update_id,
                                                            row.original.ledger_number,
                                                            row.original
                                                        )
                                                    }}
                                                />
                                            </div>
                                        ),
                                    }
                                ]}
                                //pageSize={this.state.records.length > 3 ? this.state.records.length : 3}
                                defaultPageSize={2}
                                className="-striped -highlight"
                            />

                            <DialogActions className=" justify-right pl-16  ">
                                <Button
                                    variant="raised"
                                    color="secondary"
                                    className="mx-16 mt-16 pb-15"
                                    aria-label="Save"
                                    type="button"
                                    onClick={(e) => this.addNew()}

                                //disabled={!canSubmit}
                                >
                                    Add
                                </Button>
                            </DialogActions>
                        </fieldset>


                        <div className="mt-32"></div>

                        <div className=" block bill-payment-paymode-margin">
                            <div className="w-full sm:w-1/2 md:w-2/3 p-8 inline-block bill-ayment-forn-margin">
                                <div class="w-full bg-white h-auto mt-16">
                                    <h2 className="subtitle-color">Pay Mode</h2>
                                    <DialogActions className="justify-right pl-16">
                                        <h3 className="w-full md:w-1/4  mt-24 pr-24">Total Pay Amount : {this.state.totalPayAmount}</h3>

                                    </DialogActions>
                                    <div>
                                        <Select
                                            className="w-full md:w-1/4  mt-24 pr-24 bill-payment-checkbox"
                                            name="form-field-name"
                                            placeholder="Select Pay Type"
                                            value={this.state.selectedPaymentType}
                                            disabled={this.state.payMode}
                                            onChange={this.loadPaymentTypes}
                                            options={this.state.loadPayTypes}
                                        />
                                    </div>
                                </div>


                                <div class="w-full bg-white h-auto mt-16" hidden={this.state.cashCardHidden}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <h3>If Cash</h3>
                                            <div className="w-full">
                                                <Formsy
                                                    id="cardForm"
                                                    onValidSubmit={this.addCashAmountT}
                                                    ref={(form) => this.form = form}
                                                >
                                                    <div className="w-full md:w-1/3">
                                                        <TextFieldFormsy
                                                            className="w-full md:w-2/3 pr-24 mt-16"
                                                            type="number"
                                                            name="cashAmount"
                                                            id='cash_amount'
                                                            label="Amount"
                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 pr-24">
                                                            Add
                                                    </Button>
                                                    </div>
                                                </Formsy>
                                            </div>

                                        </CardContent>
                                    </Card>
                                </div>


                                <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardCardHidden}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <h3>If Card</h3>
                                            <div className="w-full">
                                                <div className="w-full">
                                                    <Formsy
                                                        id="cardForm"
                                                        onValidSubmit={this.addCardAmountT}
                                                    >
                                                        <SelectFormsy
                                                            className="w-full md:w-1/6  mt-24 pr-24"
                                                            name="cardType"
                                                            label=""
                                                            value="none"
                                                            required
                                                        >
                                                            <MenuItem disabled value="none">
                                                                <em>Card Type</em>
                                                            </MenuItem>
                                                            <MenuItem value="visa">Visa</MenuItem>
                                                            <MenuItem value="master">Master</MenuItem>

                                                        </SelectFormsy>

                                                        <SelectFormsy
                                                            className="w-full md:w-1/6  mt-24 pr-24"
                                                            name="bankName"
                                                            label=""
                                                            value="none"
                                                            required
                                                        >
                                                            <MenuItem disabled value="none">
                                                                <em>Bank Name</em>
                                                            </MenuItem>
                                                            {/* <MenuItem value="boc">BOC</MenuItem>
                                 <MenuItem value="peoples">People's</MenuItem> */}
                                                            {this.state.loadBanks.map(function (item, i) {
                                                                return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                            })}

                                                        </SelectFormsy>

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="text"
                                                            name="cardNo"
                                                            label="Card No"
                                                            required
                                                        />

                                                        <TextFieldFormsy
                                                            id="date"
                                                            label="Expired Date"
                                                            name="expiredDate"
                                                            type="text"
                                                            className="{classes.textField} w-full md:w-1/6 mt-12 pr-24"
                                                            required
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-full md:w-1/6  mt-12 pr-24"
                                                            type="text"
                                                            name="amount"
                                                            label="Amount"

                                                            required
                                                        />

                                                        <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                            Add
                                </Button>
                                                    </Formsy>
                                                </div>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>

                                <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardChequeHidden}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <h3>If Cheque</h3>
                                            <div className="w-full sm:w-3/6 md:w-3/6">
                                                <Formsy
                                                    id="cardForm"
                                                    onValidSubmit={this.addChequeAmountT}
                                                >
                                                    <Select
                                                        className="w-full md:w-1/5  mt-24 pr-24"
                                                        name="form-field-name"
                                                        placeholder="Select Bank"
                                                        value={this.state.selectedBank}
                                                        onChange={this.loadBannkAccountNumers}
                                                        options={this.state.loadBanks}
                                                    />
                                                    {/* <SelectFormsy
                                                        className="w-full md:w-1/5  mt-24 pr-24"
                                                        name="bankName"
                                                        label=""
                                                        value="none"
                                                        required
                                                    >
                                                        <MenuItem disabled value="none">
                                                            <em>Bank Name</em>
                                                        </MenuItem>
                                                        {this.state.loadBanks.map(function (item, i) {
                                                            return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                        })}

                                                    </SelectFormsy> */}

                                                    <SelectFormsy
                                                        className="w-full md:w-1/6  mt-24 pr-24"
                                                        name="accountNo"
                                                        label=""
                                                        value="none"
                                                        required
                                                    >
                                                        <MenuItem disabled value="none">
                                                            <em>Account No</em>
                                                        </MenuItem>

                                                        {this.state.bankAccountNumbers.map(function (item, i) {
                                                            return <MenuItem value={item.value}>{item.label}</MenuItem>;
                                                        })}

                                                    </SelectFormsy>

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5  mt-12 pr-24"
                                                        type="number"
                                                        name="chequeNo"
                                                        label="Cheque No"
                                                        validations={{
                                                            minLength: 6,
                                                            maxLength: 6,
                                                            isNumeric: true
                                                        }}
                                                        validationErrors={{
                                                            minLength: 'This is not a valid  Number',
                                                            maxLength: 'This is not a valid  Number',
                                                            isNumeric: 'This is not a  Number'
                                                        }}
                                                        required
                                                    />

                                                    <TextFieldFormsy
                                                        id="date"
                                                        label="Cheque Date"
                                                        name="chequeDate"
                                                        type="date"
                                                        className="{classes.textField} w-full md:w-1/5 mt-15 pr-24 bill-payment-date"
                                                        required
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/5  mt-12 pr-24"
                                                        type="text"
                                                        name="amount"
                                                        label="Amount"
                                                        required
                                                    />

                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24">
                                                        Add
                                        </Button>
                                                </Formsy>


                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>

                                <div class="w-full bg-white h-auto mt-16" hidden={this.state.cardBankDepositHidden}>
                                    <Card className={classes.card}>
                                        <CardContent>
                                            <h3>If Bank Deposit</h3>
                                            <div className="w-full">
                                                <Formsy
                                                    id="cardForm"
                                                    onValidSubmit={this.addBankDepositAmountT}
                                                >

                                                    <SelectFormsy
                                                        className="w-full md:w-1/6  mt-24 pr-24"
                                                        name="bankName"
                                                        label=""
                                                        value="none"
                                                        required
                                                    >
                                                        <MenuItem disabled value="none">
                                                            <em>Bank Name</em>
                                                        </MenuItem>
                                                        {this.state.loadBanks.map(function (item, i) {
                                                            return <MenuItem value={item.value}>{item.value}</MenuItem>;
                                                        })}

                                                    </SelectFormsy>

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/6  mt-12 pr-24"
                                                        type="text"
                                                        name="branch"
                                                        label="Branch"
                                                        required
                                                    />

                                                    <TextFieldFormsy
                                                        id="date"
                                                        label="Deposit Date"
                                                        name="depositDate"
                                                        type="date"
                                                        className="{classes.textField} w-full md:w-1/4 mt-12 pr-24"
                                                        required
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/6  mt-12 pr-24"
                                                        type="number"
                                                        name="receiptNo"
                                                        label="Receipt No"
                                                        required
                                                    />

                                                    <TextFieldFormsy
                                                        className="w-full md:w-1/6  mt-12 pr-24"
                                                        type="text"
                                                        name="amount"
                                                        label="Amount"
                                                        required
                                                    />

                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/6 pr-24 normal-payment-add-btn">
                                                        Add
                                             </Button>
                                                </Formsy>
                                            </div>
                                        </CardContent>
                                    </Card>
                                </div>
                                <div class="w-full bg-white h-auto mt-48">
                                    <h2 className="subtitle-color paymode-padding">Payment Mode Details</h2>

                                    <ReactTable
                                        getTrProps={(state, rowInfo, column) => {
                                            return {
                                                className: "cursor-pointer",
                                                onClick: (e, handleOriginal) => {

                                                }
                                            }
                                        }}
                                        data={this.state.paymentModeAr}
                                        columns={[
                                            {
                                                Header: "rowId",
                                                accessor: "rowIdpm",
                                                show: false
                                            },

                                            {
                                                Header: "Payment Type",
                                                accessor: "paymentType",
                                                filterable: true
                                            },

                                            {
                                                Header: "Bank",
                                                accessor: "bank",
                                                filterable: true
                                            },

                                            {
                                                Header: "Cheque / Card No",
                                                accessor: "number",
                                                filterable: true
                                            },

                                            {
                                                Header: "Date",
                                                accessor: "date",
                                                filterable: true
                                            },

                                            {
                                                Header: "Amount",
                                                accessor: "paymentAmount",
                                                filterable: true
                                            },
                                            {
                                                Header: "Action",
                                                // accessor: "su",
                                                width: 128,
                                                Cell: row => (

                                                    <div className="flex items-center  w-8 h-8">
                                                        <Tooltip
                                                            enterDelay={300}
                                                            id="tooltip-controlled"
                                                            leaveDelay={300}
                                                            onClose={this.handleTooltipClose}
                                                            onOpen={this.handleTooltipOpen}
                                                            open={this.state.open}
                                                            placement="bottom"
                                                            title="Remove payment Mode"
                                                        >
                                                            <IconButton
                                                                onClick={(e) => {
                                                                    if (row) {

                                                                        this.removePaymentMode(row.original.rowIdpm, row.original.paymentAmount);

                                                                    }
                                                                }}

                                                            >
                                                                <Icon className="text-red">cancel</Icon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            }

                                        ]}
                                        defaultPageSize={3}
                                        className="-striped -highlight"
                                    />
                                </div>
                            </div>

                            <div className="w-full sm:w-1/2 md:w-1/3 p-8  inline-block">
                                <label className="w-full md:w-1/6 mt-24  pr-24">Transaction Date : {this.state.date}</label>
                                <ReactTable
                                    data={this.state.billPaymnetArry}
                                    columns={[
                                        {
                                            Header: "Supplier",
                                            accessor: "supplier",
                                            className: "justify-center",
                                            width: 100

                                        },
                                        {
                                            Header: "Ledger Number",
                                            className: "justify-center",
                                            accessor: "ledger_number_view",
                                            width: 150
                                        },
                                        {
                                            Header: 'Paid Amount',
                                            className: "justify-center",
                                            accessor: "paid_amount",
                                            width: 100,

                                        }
                                    ]}
                                    defaultPageSize={2}
                                    className="-striped -highlight"
                                />
                                <br />

                            </div>

                        </div>
                        <div className="w-full md:w-2/3"></div>

                        <DialogActions className="justify-right pl-16 bill-payment-btn-margin">
                            <Button type="button" onClick={(ev) => this.saveBillPayment()} variant="raised" size="small" color="secondary" className="mx-16 mt-16 pb-15">
                                Save
                            </Button>

                            <Button type="button" onClick={this.clearAll} variant="raised" size="small" className="mx-16 mt-16 pb-15">
                                Clear
                            </Button>

                            <Button type="button" variant="raised" size="small" color="primary" className="mx-16 mt-16 pb-15">
                                Help
                            </Button>
                        </DialogActions>
                    </Formsy>
                </div>
            )
        }
    }
}



export default withStyles(styles, { withTheme: true })(withAlert(BillPaymnet));


// WEBPACK FOOTER //
// ./src/main/content/accounting/billPayment/BillPaymnet.js